import ContactSection from "../components/ContactSection.js";
import FaqSection from "../components/FaqSection.js";
import solutionsHeroImage from "./../assets/solutions-hero-image.png";
import solutionsProductionDescriptionImage from "./../assets/solutions-product-description-image.png";
import customerEvenessGptImage from "./../assets/custom-eveness-gpt-image.png";
import evenessAlgorithmImage from "./../assets/eveness-algorithm-image.png";
import ImageCard from "../components/ImageCard.js";
import ImageCardDetails from "../components/ImageCardDetails.js";
import customDashboardImage from "./../assets/custom-dashboard-image.png";
import productInnovationImage from "./../assets/product-innovation-image.png";
import Navbar from "../components/Navbar.js";
import Sidebar from "../components/Sidebar.js";
import { homeDesktopItems, homeMobileItems } from "../data/mockData.js";
import Footer from "../components/Footer.js";
import { Link } from "react-router-dom";
import { solutionsFaqs } from "../data/faqs.js";

const Solutions = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar desktopItems={homeDesktopItems} mobileItems={homeMobileItems} />
      <main className="pl-0 md:pl-6">
        {/* Page layout: sidebar + content */}
        <div className="flex gap-1">
          {/* Sidebar */}
          <Sidebar />
          {/* Content */}
          <div className="flex-1">
            {/* HERO SECTION */}
            <section className="rounded-[10px] bg-white p-6">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                <div className="order-1 lg:order-2 lg:justify-self-end w-full">
                  <div className="w-full h-[396px] rounded-[10px] overflow-hidden relative bg-gradient-to-r from-[#E8D7D1] via-[#F0B5A9] to-[#C9C2D6]">
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="h-[82%] rounded-[8px] overflow-hidden">
                        <img
                          src={solutionsHeroImage}
                          alt="Eveness solutions hero"
                          className="w-full h-full object-contain"
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="order-2 lg:order-1 max-w-[520px]">
                  <div className="text-[32px] md:text-[38px] leading-[100%] font-normal tracking-[-1.6px] text-black font-inter">
                    The Eveness Solution
                  </div>

                  <p className="mt-4 text-[14.5px] leading-[23.4px] tracking-[0.17px] align-middle text-[#1A1A1A] max-w-[440px] font-normal">
                    Eveness provides a GPT, advanced fit &amp; style solutions,
                    and a recommendation algorithm that reorders your collection
                    pages to reduce returns specific to your branding.
                  </p>

                  <Link to="/get-started">
                    <button
                      type="button"
                      className="mt-6 inline-flex items-center justify-center w-[124px] h-[40px] rounded-[8px] px-[20px] py-[12.6px] border border-black bg-white text-black opacity-100 whitespace-nowrap transition-colors duration-200 hover:bg-black hover:text-white"
                    >
                      Get Started
                    </button>
                  </Link>
                </div>
              </div>{" "}
            </section>
            {/* SECOND SECTION */}
            <section className="mt-[40px] md:mt-[100px] rounded-[10px] bg-white p-6 mb-[50px]">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch bg-white">
                <ImageCard
                  imageSrc={solutionsProductionDescriptionImage}
                  bgColor={"#F7F6F2"}
                />
                <ImageCardDetails
                  title="Eveness Product Description Page Widget"
                  description="Learn the best colors, silhouettes, and necklines based on your Color Analysis, Face, and Body Shape."
                  linkTextOne="Fit, Size, and Style Guidance for Every Product"
                  linkTextTwo="Increase Conversions. Reduce Returns."
                />
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch mt-[50px] bg-white">
                <div className="order-2 lg:order-1">
                  <ImageCardDetails
                    title="Custom Eveness GPT"
                    description="Your Brand Chatbot powered with your product catalogue."
                    linkTextOne="AI Shopping Assistant Trained on Your Catalog"
                    linkTextTwo="Answers Product, Fit, and Style Questions Instantly"
                  />
                </div>
                <div className="order-1 lg:order-2">
                  <ImageCard
                    imageSrc={customerEvenessGptImage}
                    bgColor={"#F2F7F5"}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch mt-[50px]">
                <ImageCard
                  imageSrc={evenessAlgorithmImage}
                  bgColor={"#F7F2F2"}
                  source={"demo"}
                />
                <ImageCardDetails
                  title="The Eveness Algorithm"
                  description="A Recommender Algorithm Trained of Styling Research, that looks at the user’s features and the garment to help match the most flattering garments."
                  linkTextOne="Fit Intelligence Trained on Styling Research"
                  linkTextTwo="Matches Customers to the Most Flattering Products"
                />
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch mt-[50px] bg-white">
                <div className="order-2 lg:order-1">
                  <ImageCardDetails
                    title="Merchandising and Performance Analytics"
                    description="A brand dashboard for data-driven merchandising, tracking fit intelligence, style data, and customer behavior."
                    linkTextOne="Brand Analytics for Fit and Style Data"
                    linkTextTwo="Track Performance, Returns, and Preferences"
                  />
                </div>
                <div className="order-1 lg:order-2">
                  <ImageCard
                    imageSrc={customDashboardImage}
                    bgColor={"#F7F2F7"}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch mt-[50px]">
                <ImageCard
                  imageSrc={productInnovationImage}
                  bgColor={"#F2F6F7"}
                />
                <ImageCardDetails
                  title="SMS and Email AI Agent"
                  description="Send personalized fit, size, and style guidance directly to shoppers through automated SMS and email."
                  linkTextOne="Personalized Fit and Size Recommendations via Messaging"
                  linkTextTwo="Increase Conversions & Responsive Customer Engagement"
                />
              </div>
            </section>

            <section className="mt-10 rounded-[10px] px-3 md:px-6">
              <ContactSection />
              <div className="mt-[52px]">
                <FaqSection faqs={solutionsFaqs}/>
              </div>
            </section>
            <Footer/>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Solutions;
